/**
 * Note that this should match the UUID namespaces used in the KG.
 */
export enum UuidNamespace {
  AccountToPersonalSpaceNamespace = "a5c8c855-37fe-4572-bbb8-66bd15fefdba",
  SyncModelNamespace = "DED407F4-2931-4A2F-875D-62B9196F9060",
  HeadsUpBriefNamespace = "E0657800-7BFC-4646-ACB2-37087E8455D2",
  SmartContextNamespace = "0CCCE77F-6835-4CF9-A263-57DAFBAAA218",
  LocalAudioRecordingNamespace = "F0657800-7BFC-4646-ACB2-37087E8455D2",
  DefaultCalendarEventTemplateNamespace = "4372B0CD-AC5F-434B-99BA-114A7347A35E",
  VoiceSessionArtifactNamespace = "22AA7B3C-1BE4-45EE-AE79-AE95E8AE6DDC",
}
